import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { Dropdown } from "@gemini/ui";
import { Controller } from "react-hook-form";
import { householdTypeTestId } from "./constants";
import { useDropdownItems } from "./useDropdownItems";
export const HouseholdTypeInput = ({ control }) => {
    const { t } = useI18n();
    const isPreviewMode = useIsPreviewMode();
    const defaultItems = useDropdownItems("contact.form.household_type_items", 4);
    return (_jsx(Controller, { name: "householdType", control: control, defaultValue: "", render: ({ fieldState: { error }, field }) => (_jsx(Dropdown, Object.assign({}, (error && {
            error: t("contact.form.household_type_error_empty"),
        }), field, { defaultValue: "", label: t("contact.form.household_type"), testId: householdTypeTestId, placeholder: t("contact.form.please_select"), defaultItems: defaultItems, isDisabled: isPreviewMode }))) }));
};
